import PhotoCardData from "./PhotoCardData";
import PhotoCardMenu from "./PhotoCardMenu";
import PhotoCardPhotos from "./PhotoCardPhotos";
import OriginalPhotoCard from "./PhotoCard";
var PhotoCard = OriginalPhotoCard;
PhotoCard.Data = PhotoCardData;
PhotoCard.Menu = PhotoCardMenu;
PhotoCard.Photos = PhotoCardPhotos;
export default PhotoCard;
